(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["floating-contact"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('espybd-contact')) {
    customElements.define('espybd-contact', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.events = new AbortController();
        const signal = this.events.signal;
        const disclosure = this.querySelector('details');
        const launcher = this.querySelector('summary');
        if (!disclosure || !launcher) return;
        const close = (restoreFocus = false) => {
          disclosure.open = false;
          if (restoreFocus) launcher.focus({preventScroll: true});
        };
        this.querySelector('.kk-contact__close').addEventListener('click', () => close(true), {signal});
        document.addEventListener('pointerdown', (event) => {
          if (disclosure.open && !this.contains(event.target)) close();
        }, {signal});
        document.addEventListener('focusin', (event) => {
          if (disclosure.open && !this.contains(event.target)) close();
        }, {signal});
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && disclosure.open) close(true);
        }, {signal});
        const checkOverlap = () => {
          this.frame = null;
          if (disclosure.open) {
            this.removeAttribute('data-obstructed');
            return;
          }
          const bubble = launcher.getBoundingClientRect();
          const obstructed = [...document.querySelectorAll('.product-form__actions, .product-card__quick, .cart-summary button, .cart-summary a.button')].some((target) => {
            const box = target.getBoundingClientRect();
            return box.width > 0 && box.height > 0 && getComputedStyle(target).visibility !== 'hidden' && box.left < bubble.right + 8 && box.right > bubble.left - 8 && box.top < bubble.bottom + 8 && box.bottom > bubble.top - 8;
          });
          this.toggleAttribute('data-obstructed', obstructed);
        };
        const schedule = () => {
          if (this.frame == null) this.frame = requestAnimationFrame(checkOverlap);
        };
        window.addEventListener('scroll', schedule, {passive: true, signal});
        window.addEventListener('resize', schedule, {passive: true, signal});
        window.addEventListener('load', schedule, {signal});
        document.addEventListener('shopify:section:load', schedule, {signal});
        disclosure.addEventListener('toggle', schedule, {signal});
        this.resizeObserver = new ResizeObserver(schedule);
        this.resizeObserver.observe(document.body);
        schedule();
      }
      disconnectedCallback() {
        this.events?.abort();
        this.resizeObserver?.disconnect();
        if (this.frame != null) cancelAnimationFrame(this.frame);
        this.frame = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
